const UUID_BYTE_LENGTH = 16

const UUID_HEX = Array.from({ length: 256 }, (_, index) => index.toString(16).padStart(2, '0'))

function fillRandomBytes() {
  const bytes = new Uint8Array(UUID_BYTE_LENGTH)
  const cryptoApi = globalThis.crypto

  if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
    return cryptoApi.getRandomValues(bytes)
  }

  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256)
  }

  return bytes
}

function formatUuidFromBytes(bytes) {
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hexParts = Array.from(bytes, byte => UUID_HEX[byte])

  return [
    hexParts.slice(0, 4).join(''),
    hexParts.slice(4, 6).join(''),
    hexParts.slice(6, 8).join(''),
    hexParts.slice(8, 10).join(''),
    hexParts.slice(10, 16).join(''),
  ].join('-')
}

export function createRuntimeUuid() {
  const cryptoApi = globalThis.crypto
  const randomUuidFactory = cryptoApi?.randomUUID

  if (typeof randomUuidFactory === 'function') {
    return randomUuidFactory.call(cryptoApi)
  }

  return formatUuidFromBytes(fillRandomBytes())
}
